export const ROLES = {
    BETTERSPACE_ADMIN: "BETTERSPACE_ADMIN",
    COMPANY_ADMIN: "COMPANY_ADMIN",
    LOCATION_ADMIN: "LOCATION_ADMIN",
    NON_TECHNICAL_USER: "NON_TECHNICAL_USER",
    TECHNICAL_USER: "TECHNICAL_USER",
};

export const STATUSES = {
    ACTIVE: "ACTIVE",
    PENDING: "PENDING",
};

export const MODALS = {
    ADD_USER: "ADD_USER",
    ADD_MULTI_COMPANY: "ADD_MULTI_COMPANY",
    EDIT_PROFILE: "EDIT_PROFILE",
    EDIT_MULTI_COMPANY: "EDIT_MULTI_COMPANY",
};

export enum AdministrationLevelEnum {
    GLOBAL = "GLOBAL",
    COMPANY = "COMPANY",
    LOCATION = "LOCATION",
}
